import React from 'react';
import { useQueryContext } from '@sierralabs/query-ui';
import SiteQueryFieldPicker from '../../common/pickers/SiteQueryFieldPicker';
import { useGetQueriesForComponentTree } from '../../hooks/component/useGetQueriesForComponentTree';
import { getQueryValue } from '../../hooks/component/useQueryDisplayValue';
import { useSiteContext } from '../../SiteContext';
const SiteQueryFieldParamConfigurator = ({ config, onChange }) => {
    const { configureComponent } = useSiteContext();
    const queries = useGetQueriesForComponentTree(configureComponent);
    return (React.createElement(React.Fragment, null,
        React.createElement(SiteQueryFieldPicker, { variant: 'outlined', queryId: config === null || config === void 0 ? void 0 : config.queryId, queryField: config === null || config === void 0 ? void 0 : config.queryField, options: queries, onChange: config => {
                onChange === null || onChange === void 0 ? void 0 : onChange(config);
            } })));
};
export const SiteQueryFieldParamPlugin = {
    name: 'Query Field Parameter',
    type: 'query-field-parameter',
    configurator: SiteQueryFieldParamConfigurator,
    getParamValue: (config, context, data) => {
        const { queries } = context.queryContext;
        const query = queries.find(query => query.id === config.queryId);
        if (query && config.queryField) {
            return getQueryValue(data, query, config.queryField);
        }
        else {
            throw new Error('Invalid query and queryField');
        }
    },
    useHook: () => {
        const queryContext = useQueryContext();
        return { queryContext };
    }
};
//# sourceMappingURL=SiteQueryFieldParamPlugin.js.map